import { render, staticRenderFns } from "./editanimalAge.vue?vue&type=template&id=2549c3e8"
import script from "./editanimalAge.vue?vue&type=script&lang=js"
export * from "./editanimalAge.vue?vue&type=script&lang=js"
import style0 from "./editanimalAge.vue?vue&type=style&index=0&id=2549c3e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports